import React from 'react';
import { humanizeNumber } from '../../helpers/formatters';
import styles from './bar-chart.module.scss';
export default function Legend({ min, max, unit, children, title }) {
  return (
    <div className={styles.barChartLegend}>
      <div>{humanizeNumber(min, unit)}</div>
      <div>
        {title === 'Power stations'
          ? humanizeNumber(max, unit) +
            ' (total of ' +
            children[1] +
            ' owned power stations)'
          : humanizeNumber(max, unit)}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/bar-chart/legend.js